import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { useAppSelector, useAppDispatch } from '../../../../store';
import { DataElementContext } from '../../../../page-components/common/DataElementContext';

import { ticketWinnerFunSettledListRequest } from '../../../../modules/bets/store/actions/tickets';
import { buildTicketLists } from '../utils/functions';

import './index.scss';
import { useTranslation } from 'react-i18next';

type BetsSettledProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: {
    dsType: string;
  };
};

const defaultProps = {
  className: '',
  styleText: '',
  properties: {
    dsType: '',
  },
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const BetsSettled = (componentProps: BetsSettledProps) => {
  const tmpProps = { ...defaultProps, ...componentProps };
  delete tmpProps.children;
  const props = JSON.parse(JSON.stringify(tmpProps));
  const { children } = componentProps;

  const dispatch = useAppDispatch();
  const settled = useAppSelector((state) => state.bets.ticketsWinnerFun.ticketsSettled);
  const inProgress = useAppSelector((state) => state.bets.ticketsWinnerFun.requestInProgress.settled);
  const showMore = useAppSelector((state) => state.bets.ticketsWinnerFun.showMore);

  const [page, setPage] = React.useState<number | null>(null);
  const [extended, setExtended] = React.useState<any>({});
  const { i18n, t } = useTranslation();

  const onExtend = React.useCallback((e: React.MouseEvent<HTMLElement>) => {
    if (e.currentTarget.dataset.hash != null && e.currentTarget.dataset.hash !== '') {
      const hash = e.currentTarget.dataset.hash;
      setExtended((prevState: any) => ({
        ...prevState,
        [hash]: prevState[hash] != null ? !prevState[hash] : true,
      }));
    }
  }, []);

  const handleChangePage = React.useCallback(() => {
    setPage((page) => (page ?? 0) + 1);
  }, []);

  React.useEffect(() => {
    setPage(1);
  }, []);

  React.useEffect(() => {
    if (page === null) return;
    dispatch(ticketWinnerFunSettledListRequest({ page, winnerFun: true }));
  }, [page]); //eslint-disable-line

  const contextValue = React.useMemo(() => {
    const contextValue = {
      tickets: buildTicketLists(settled, extended, i18n.language, t, true, null, {}),
      inProgress,
      onExtend,
      showMore,
      handleChangePage,
    };

    return contextValue;
  }, [settled, inProgress, extended, onExtend, handleChangePage, showMore, i18n.language, page, t]);

  //console.log('BetsSettled[contextValue]: ', contextValue);

  return (
    <ModuleElementDiv className={props.className ?? ''} $styleText={props.styleText}>
      <DataElementContext.Provider value={contextValue}>{children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default BetsSettled;
